import React from "react";
import AnimatedCursor from "react-animated-cursor";
import Navigation from "./components/Navigation/Navigation";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Skills from "./components/Skills/Skills";
import Contact from "./components/Contact/Contact";
import Atmosphere from "./components/Atmosphere/Atmosphere";
import { HelmetProvider } from "react-helmet-async";
import SEO from "./components/SEO/SEO";
import useFinePointer from "./hooks/useFinePointer";
import usePrefersReducedMotion from "./hooks/usePrefersReducedMotion";
import "./App.scss";

function App() {
  const finePointer = useFinePointer();
  const reduceMotion = usePrefersReducedMotion();
  const shouldRenderCustomCursor = finePointer && !reduceMotion;

  return (
    <HelmetProvider>
      <div className="app">
        <SEO />
        <a className="skip-link" href="#main-content">
          Skip to main content
        </a>
        {shouldRenderCustomCursor && (
          <AnimatedCursor
            innerSize={8}
            outerSize={35}
            innerScale={1}
            outerScale={2}
            outerAlpha={0}
            hasBlendMode={true}
            innerStyle={{
              backgroundColor: "#4F5D75"
            }}
            outerStyle={{
              border: "2px solid rgba(79, 93, 117, 0.55)"
            }}
            clickables={[
              "a",
              "input[type=\"text\"]",
              "input[type=\"email\"]",
              "input[type=\"submit\"]",
              "textarea",
              "button",
              ".link",
              ".navigation__logo",
              ".nav-link",
              ".projects__card",
              ".hero__chip",
              ".tech-pill",
              ".social-links a"
            ]}
          />
        )}
        <Atmosphere />
        <Navigation />
        <main id="main-content" className="app__main" tabIndex="-1">
          <Hero />
          <About />
          <Skills />
          <Projects />
          <Contact />
        </main>
      </div>
    </HelmetProvider>
  );
}

export default App;
